import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import './BecomePartner.css'
import MoreImagesCard from '../../components/MoreImagesCard';
import { useTranslation } from 'react-i18next';
import SendConfirmation from '../../pages/contact/SendConfirmation';
import useLanguagePrefix from '../../LanguagePrefix';


function BecomePartner() {
    const { t } = useTranslation();
    const [isSent, setIsSent] = useState(false);
    const [isFormat, setIsFormat] = useState(true);
    const langPrefix = useLanguagePrefix();

    const [formData, setFormData] = useState({
        fullName: "",
        role: "Owner/Founder",
        phoneNumber: "",
        email: "",
        message: ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "phoneNumber") {
            let cleanedValue = value.replace(/[^\d+]/g, "");

            if (cleanedValue.includes("+")) {
                cleanedValue = "+" + cleanedValue.replace(/\+/g, "").replace(/^\+/, "");
            }

            setFormData({ ...formData, [name]: cleanedValue });
            return;
        }

        setFormData({ ...formData, [name]: value });
    };

    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (isFormat) {
            try {
                const response = await fetch("https://api.prostay.com/Website/become-a-partner", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(formData)
                });
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }

                setIsSent(true);
                setFormData({ fullName: "", role: "", email: "", phoneNumber: "", message: "" });
            }
            catch (error) {
                console.error("Error sending request:", error);
            }
        }
    };

    const isDisabledButton = formData.fullName.trim() === "" || formData.role.trim() === "" ||
        formData.email.trim() === "" || !isValidEmail(formData.email);

    return (
        <div>
            <Helmet>
                <title>Prostay – Partner With Us | Reseller & Integration Program</title>
                <meta name="description" content="Join the Prostay Partner Program and grow with us. Designed for resellers, consultants, and integration partners." />
                <link rel="canonical" href={"https://www.prostay.com" + langPrefix + "/become-a-partner/"} />

                <link rel="alternate" href="https://www.prostay.com/en/become-a-partner/" />
                <link rel="alternate" href="https://www.prostay.com/es/become-a-partner/" />

                <meta property="og:title" content="Prostay – Partner With Us | Reseller & Integration Program" />
                <meta property="og:description" content="Join the Prostay Partner Program and grow with us. Designed for resellers, consultants, and integration partners." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={"https://www.prostay.com" + langPrefix + "/become-a-partner/"} />
                <meta property="og:image" content='https://prostay.com/images/ogImage.png' />

                <meta property="og:site_name" content="Prostay" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Prostay – Partner With Us | Reseller & Integration Program" />
                <meta name="twitter:description" content="Join the Prostay Partner Program and grow with us. Designed for resellers, consultants, and integration partners." />
                <meta name="twitter:image" content='https://prostay.com/images/ogImage.png' />
                <meta name="twitter:site" content="@prostaypms" />
                <meta name="twitter:creator" content="@prostaypms" />


            </Helmet>
            <div className='become-partner'>
                <div className='background-image'>
                    <div className='background-image-start'>
                        <div className='mt-2 d-flex align-items-center gap-1 chip'>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M14.3993 8.4C14.0811 8.4 13.7758 8.27357 13.5508 8.04853C13.3257 7.82348 13.1993 7.51826 13.1993 7.2C13.1993 6.88174 13.3257 6.57652 13.5508 6.35147C13.7758 6.12643 14.0811 6 14.3993 6H20.3993C20.7176 6 21.0228 6.12643 21.2478 6.35147C21.4729 6.57652 21.5993 6.88174 21.5993 7.2V13.2C21.5993 13.5183 21.4729 13.8235 21.2478 14.0485C21.0228 14.2736 20.7176 14.4 20.3993 14.4C20.0811 14.4 19.7758 14.2736 19.5508 14.0485C19.3257 13.8235 19.1993 13.5183 19.1993 13.2V10.0968L14.0477 15.2484C13.8227 15.4734 13.5175 15.5997 13.1993 15.5997C12.8811 15.5997 12.576 15.4734 12.3509 15.2484L9.59932 12.4968L4.44772 17.6484C4.22139 17.867 3.91827 17.9879 3.60364 17.9852C3.289 17.9825 2.98802 17.8563 2.76553 17.6338C2.54304 17.4113 2.41684 17.1103 2.41411 16.7957C2.41137 16.481 2.53233 16.1779 2.75092 15.9516L8.75092 9.9516C8.97595 9.72664 9.28112 9.60026 9.59932 9.60026C9.91751 9.60026 10.2227 9.72664 10.4477 9.9516L13.1993 12.7032L17.5025 8.4H14.3993Z" fill="#1643E0" />
                            </svg>
                            {t('Knowledge Base')}
                        </div>
                        <div className='mt-2' style={{ maxWidth: '550px' }}>
                            <h1>
                                {t('Become a partner')}
                            </h1>
                            <p className='mt-4 bigger-text'>
                                {t('Cutting-edge Property Management System designed to revolutionize the way hotels, and resorts from boutique to large-scale, operate and serve their guests.')}
                            </p>
                        </div>
                    </div>
                </div>

                {isSent && isFormat ? (
                    <SendConfirmation />
                ) : (
                    <div className='padding-inline-phone'>
                        <div className='form-container'>
                            <h4 style={{ maxWidth: '340px' }}>{t('Let’s collaborate, became a partner')}</h4>
                            <form onSubmit={handleSubmit} className="form-submit mt-4">
                                <div className="group-input">
                                    <div className='d-flex flex-column width-second-row gap-1'>
                                        <small>{t('Full Name*')}</small>
                                        <input
                                            type="text"
                                            name="fullName"
                                            value={formData.fullName}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className='d-flex flex-column width-second-row gap-1'>
                                        <small>{t('Role*')}</small>
                                        <select style={{ appearance: 'none' }} name="role" value={formData.role} onChange={handleChange}>
                                            <option value="Owner/Founder">{t('Owner/Founder')}</option>
                                            <option value="General Manager">{t('General Manager')}</option>
                                            <option value="Operations Manager">{t('Operations Manager')}</option>
                                            <option value="Sales & Marketing">{t('Sales & Marketing')}</option>
                                            <option value="IT Department">{t('IT Department')}</option>
                                            <option value="Revenue Management">{t('Revenue Management')}</option>
                                            <option value="Consultant">{t('Consultant')}</option>
                                            <option value="Other">{t('Other')}</option>
                                        </select>
                                        <svg className='svg-arrow' width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6 9.5L12 15.5L18 9.5" stroke="#808698" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <div className="group-input">
                                    <div className='d-flex flex-column width-second-row gap-1'>
                                        <small>{t('E-mail*')}</small>
                                        <input
                                            type="text"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className='d-flex flex-column width-second-row gap-1'>
                                        <small>{t('Phone Number')}</small>
                                        <input
                                            type="text"
                                            name="phoneNumber"
                                            value={formData.phoneNumber}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div className='d-flex flex-column gap-1'>
                                    <small>{t('Message (Optional)')}</small>
                                    <textarea style={{ height: "153px" }}
                                        name="message"
                                        value={formData.message}
                                        onChange={handleChange}
                                        placeholder={t('Send us your message')}
                                    ></textarea>
                                </div>
                                <div className='d-flex justify-content-end mt-4'>
                                    <button type="submit" className={`width-full ${isDisabledButton ? "disabled-filled-btn-small" : "light-blue-filled-btn-small"}`} style={{ paddingInline: '20px' }} disabled={isDisabledButton}>
                                        {t('Send')}
                                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M21 12.5H3H21Z" fill="white" />
                                            <path d="M14 5.5L21 12.5M21 12.5L14 19.5M21 12.5H3" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>
                            </form>
                            {/*
                            <p className='mt-4'>
                                {t('The promotions module allows businesses to set dynamic pricing strategies, offer seasonal discounts, and track the performance of promotional campaigns in real time.')}
                            </p> */}
                        </div>
                    </div>
                )}
                <div style={{ marginBottom: '50px' }}>
                    <MoreImagesCard />
                </div>
            </div>
        </div>
    );
}

export default BecomePartner;
